import Appbar from 'components/appbar/Appbar';
import PageHeaderActions from 'components/page-header/PageHeaderActions';
import NewRecordButton from 'components/page-header/NewRecordButton';
import React from 'react';
import HospitalAction from './HospitalAction';
import { useFetchHospitals } from './hooks/useFetchHospitals';
import HospitalFilterBox from './HospitalFilterBox';
import PaginationProvider from 'hooks/pagination';
import { useDisplayMode } from 'hooks/useDisplayMode';
import TableLoading from 'components/loading/TableLoading';
import ModuleLoading from 'components/loading/ModuleLoading';
import NoData from 'components/no-data/NoData';
import HospitalListTable from './list/table/HospitalListTable';
import Pagination from 'components/pagination/Pagination';
import HospitalListModule from './list/module/HospitalListModule';

const Hospital: React.FC = () => {
  const {
    hospitals,
    loading,
    handleSearch,
    filter,
    handleChange,
    handleSort,
    orderedIndex,
    setPage,
    setRows,
    page,
    rows,
    total,
  } = useFetchHospitals();
  const [displayMode] = useDisplayMode();

  return (
    <>
      <Appbar title="Hospitais" ActionsComponent={<HospitalAction />} />
      <PageHeaderActions
        title="Hospitais"
        description="Gestão de hospitais"
        ActionComponent={<NewRecordButton label="Novo hospital" to="/hospitals/new" />}
      />

      <HospitalFilterBox loading={loading} handleChange={handleChange} filter={filter} handleSearch={handleSearch} />

      <PaginationProvider rowsPerPage={rows}>
        {loading ? (
          displayMode === 'list' ? (
            <TableLoading />
          ) : (
            <ModuleLoading />
          )
        ) : hospitals.length === 0 ? (
          <NoData message="Nenhum hospital encontrado" />
        ) : (
          <>
            {displayMode === 'list' ? (
              <HospitalListTable hospitals={hospitals} />
            ) : (
              <HospitalListModule hospitals={hospitals} />
            )}

            <Pagination
              count={total}
              currentPage={page}
              currentRowsPerPage={rows}
              onChangePage={page => setPage(page)}
              onChangeRowsPerPage={rows => setRows(rows)}
            />
          </>
        )}
      </PaginationProvider>
    </>
  );
};

export default Hospital;
